import { render, staticRenderFns } from "./AddBulletin.vue?vue&type=template&id=57307597&"
import script from "./AddBulletin.vue?vue&type=script&lang=js&"
export * from "./AddBulletin.vue?vue&type=script&lang=js&"
import style0 from "./AddBulletin.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddBulletin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports